<template>
    <div v-if="!alreadySubmitted" class="offer-banner">
        <div class="offer-banner__icon">
            <i class="fas fa-hand-holding-heart"></i>
        </div>
        <p class="offer-banner__title">I got more to offer!</p>
        <p class="offer-banner__subtitle">Want to contribute beyond food distributions?</p>
        <router-link to="/offer-help" class="button is-primary is-rounded offer-banner__btn">
            <span>Find out how</span>
            <span class="icon"><i class="fas fa-arrow-right"></i></span>
        </router-link>
    </div>
</template>

<script>
export default {
    async created() {
        const userID = this.$store.getters['user/getCurrentUserID'];
        if (userID) {
            await this.$store.dispatch('interests/checkUserHasSubmitted', userID);
        }
    },
    computed: {
        alreadySubmitted() {
            return this.$store.getters['interests/getHasSubmitted'];
        }
    }
}
</script>

<style scoped>
.offer-banner {
    margin-top: 1rem;
    padding: 1.25rem 1.5rem;
    background: linear-gradient(135deg, #f0f4ff 0%, #e8f5e9 100%);
    border: 1px solid #c3d9ff;
    border-radius: 16px;
    text-align: center;
    animation: banner-enter 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.4s both;
}

@keyframes banner-enter {
    from { opacity: 0; transform: translateY(18px); }
    to   { opacity: 1; transform: translateY(0); }
}

.offer-banner__icon {
    font-size: 2rem;
    color: #4f46e5;
    margin-bottom: 0.5rem;
    display: inline-block;
    animation: icon-float 2.8s ease-in-out 1.2s infinite;
}

@keyframes icon-float {
    0%, 100% { transform: translateY(0) scale(1); }
    40%       { transform: translateY(-6px) scale(1.12); }
    60%       { transform: translateY(-4px) scale(1.08); }
}

.offer-banner__title {
    font-size: 1.1rem;
    font-weight: 800;
    color: #1f2937;
    margin-bottom: 0.25rem;
}

.offer-banner__subtitle {
    font-size: 0.9rem;
    color: #6b7280;
    margin-bottom: 1rem;
}

.offer-banner__btn {
    font-weight: 600;
    animation: btn-pulse 2.4s ease-in-out 1.8s infinite;
}

@keyframes btn-pulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(72, 199, 142, 0); }
    50%       { box-shadow: 0 0 0 8px rgba(72, 199, 142, 0.28); }
}

@media (prefers-reduced-motion: reduce) {
    .offer-banner,
    .offer-banner__icon,
    .offer-banner__btn { animation: none; }
}
</style>
